import script from "./myheader.vue?vue&type=script&setup=true&lang=js"
export * from "./myheader.vue?vue&type=script&setup=true&lang=js"

import "./myheader.vue?vue&type=style&index=0&id=745ddde4&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/pay.7pa.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-745ddde4"]])

export default __exports__